<template>
<div>
<div style="padding: 1px 3px 1px 3px">
    <table style="width:100%">
        <tr>
            <td>
                    <input slot="reference" type="text" v-model="search" ref="search" placeholder="Search..." class="no-border"
                            style="padding:8px;border: solid 0px #888; color:#666; width:100%; font-size:15px"/>  
               
            </td>
            <td style="width:1%">
                <v-btn v-if="searchMode" @click="clearSearch" style="float:right" icon><v-icon style="font-size:18px" color="grey darken-1" small>close</v-icon></v-btn>
                <GroupSelector v-else :settings="{multiselect: false, title:'Show Contacts for Group'}" @select="groupSelected" style="float:right" />
            </td>
        </tr>

    </table>  

</div>        
        
<!-- Contacts -->

<v-list two-line style="padding-top:0px;border-radius:6px">
    <template v-for="(contact, i) in contacts">    
        <v-list-item @click.stop="contactClicked(contact)" :key="contact.meta.tenantKey + '|' + contact.meta.key">
        <div style="padding-right:10px">
        <ContactImage :contact="contact" :size="45" />
        </div>
        <!-- <v-list-item-avatar>
            <img v-if="contact.image" :src="getContactImage(contact)" :title="officeNameFromKey(contact.meta.tenantKey)"/>
            <img v-else v-bind:src="'https://placeimg.com/40/40/people/' +i"/>
        </v-list-item-avatar> -->
        <v-list-item-content>
            <v-list-item-title>
                {{contact | fullName}}
                <span v-if="contact.partner" class="grey--text text--lighten-1"> and {{contact.partner.firstName}}</span>
            </v-list-item-title>
            <v-list-item-subtitle style="line-height:1.5">
                <div style="font-size:11px;background-color:yellow;display:inline-block;line-height:0.9em;" v-if="contact.preferredName">Prefer<br/>{{contact.preferredName}}</div>
                {{contact | phoneNumbers}} 
                <flag style="font-size:12px" :value="initials(contact.owner)" :title="officeNameFromKey(contact.meta.tenantKey)"/>
                <flag v-if="contact.user" style="font-size:12px" value="User" purple :title="contact.meta.key"/>
            </v-list-item-subtitle>
        </v-list-item-content>
        <ListJumpButton v-if="$listeners.jump" tooltip="Jump to Latest Transaction" @click="jump(contact)" />
        </v-list-item>
        <v-divider :key="'d-' + i" />
    </template>


    <!-- Loader -->
    <div class="grey--text pa-3" v-if="loading">
        <v-progress-circular style="display:block;margin:auto" indeterminate color="grey lighten-1"></v-progress-circular>
    </div>
    <!-- </v-col> -->

    <!-- Option to Add -->
    <v-list-item v-if="noResults" @click.stop="$emit('add')">
        <v-list-item-avatar>
            <v-icon x-large class="grey--text text--lighten-2">add_circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title>Add Contact</v-list-item-title>
            <v-list-item-subtitle>No results. Add a new one?</v-list-item-subtitle>
        </v-list-item-content>
    </v-list-item>

</v-list>


</div>
</template>

<script>
import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import StringHelpers from '../helpers/StringHelpers'
import Utilities from '../helpers/Utilities'
import ContactHelpers from '../helpers/ContactHelpers'
import DataHelpers from '../helpers/DataHelpers'
import Flag from '../ui-elements/Flag'
import GroupSelector from '../ui-elements/GroupSelector'
import ListJumpButton from '../ui-elements/ListJumpButton'
import ContactImage from '../flow/ui/ContactImage'
import NiceData from '../data/NiceData'
import OrderHelpers from '../helpers/OrderHelpers'
import TeamHelpers from '../helpers/TeamHelpers'


    export default {
    props:{
        visible: Boolean,
        role: String,
        global: Boolean,
    },
    components: {
        Flag,
        GroupSelector,
        ListJumpButton,
        ContactImage,
        // 'popper': Popper,
    },     
    data() {
        return {
            blankAvatars: false,
            loading: false,
            listeners: {},
            search: '',
            contactsByOffice: {},
            showingGroups: false,
            dialogVisible: false,
            group: {
                name: null,
                role: false,
            }, 
            groups: []
        }
    },
    computed: {
        tenantKey() {
            return DataHelpers.getTenantKey()
        },
        contacts() {

            let searchParameters = ContactHelpers.searchAnalysis(this.search)

            let contacts = []
            for(let officeCode in this.contactsByOffice) {
                contacts = [...contacts, ...this.contactsByOffice[officeCode]]
            }

            if(this.search.length < 3 || searchParameters.type == 'mobile')
                return contacts

            let names = ContactHelpers.searchNames(this.search)
            
            return contacts.filter(o => {
                if(!o.firstName || !o.lastName)
                    return true

                if(o.firstName.startsWith(names.primaryName) && o.lastName.startsWith(names.secondaryName))
                    return true

                if((o.lastName.startsWith(names.primaryName) && o.firstName.startsWith(names.secondaryName)))
                    return true
                
                return false
            }

            ).slice(0,20)
        },

        noResults() {
            return this.contacts.length < 1
        },

        searchMode() {
            return this.search.length > 0
        },

    },
    methods: {

        getContactImage(contact) {
            return ContactHelpers.getContactImage(contact, this.blankAvatars)
        },

        officeNameFromKey(key) {
            return DataHelpers.officeNameFromKey(key)
        },

        groupSelected(group) {
            console.log('ContactSearch > groupSelected', group)
        },

        initials(contact) {
            return ContactHelpers.initials(contact) || 'No Owner'
        },

        clearSearch() {
            this.search = ''
            if(!Utilities.isMobile())
                this.$refs.search.focus()
        },

        contactClicked(contact) {
            this.$emit('click', contact, this.data)
        },

        focus() {
            this.$refs.search.focus()
        },

        jump(contact) {
            this.$emit('jump', contact, this.data)
        },


        clickedCancel() {
            this.$emit('cancel')
        },

        debouncedRunSearch: Utilities.debounce( function(searchText) {
            this.runSearch(searchText)
        },700),

        runSearch(searchText) {
            
            let searchParameters = ContactHelpers.searchAnalysis(searchText)
            
            if(searchParameters.type == 'waiting')
                return

            if(['names', 'recent', 'mobile'].includes(searchParameters.type))
                this.getContacts(searchParameters)
            
            setTimeout( () => {
                this.$emit('search', searchText)
            })
        },

        getContacts(searchParameters) {
            this.clearListeners()
            
            let index = -1
            let firstNameRefs = []
            let lastNameRefs = []
            this.loading = true
 
            //for single office search...
            let offices = []
            if(!this.global) {
                console.log('Gettting contacts for office: ' + this.tenantKey)
                offices.push({meta:{
                    key: this.tenantKey
                }})
            }

            //for multiple office search...
            if(this.global)
                offices = this.$store.getters.officesActive

            //for recent search, object needs to be cleared to prevent surname searches from lingering...
            if(searchParameters.type != 'names')
                this.contactsByOffice = {}

            offices.forEach(office => {
            
                index += 1
                firstNameRefs[index] = DataHelpers.getRootRef().child('tenants').child(office.meta.key).child('contacts')
                
                if(searchParameters.type == 'names')
                    firstNameRefs[index] = firstNameRefs[index].orderByChild('firstName').startAt(searchParameters.primaryName).endAt(searchParameters.primaryName + '\uf8ff')
                if(searchParameters.type == 'recent')
                    //firstNameRefs[index] = firstNameRefs[index].orderByChild('user').equalTo(null)
                    firstNameRefs[index] = firstNameRefs[index].orderByChild('openedAt')
                if(searchParameters.type == 'mobile')
                    firstNameRefs[index] = firstNameRefs[index].orderByChild('mobileSearch').equalTo(searchParameters.search)
                
                firstNameRefs[index] = firstNameRefs[index].limitToLast(10)
                
                if(!this.listeners[office.meta.key])
                    this.listeners[office.meta.key] = []
                let listenersForOffice = this.listeners[office.meta.key]

                listenersForOffice[listenersForOffice.length] = firstNameRefs[index].on('value', snap => {
                    let contacts = NiceData.arrayFromSnapshot(snap).sort(OrderHelpers.sortByOpenedAtDescending)
                    this.$set(this.contactsByOffice, office.meta.key, contacts)
                    this.loading = false
                })
                

                if(searchParameters.type == 'names') {

                    lastNameRefs[index] = DataHelpers.getRootRef().child('tenants').child(office.meta.key).child('contacts')
                                        
                    lastNameRefs[index] = lastNameRefs[index].orderByChild('lastName').startAt(searchParameters.primaryName).endAt(searchParameters.primaryName + '\uf8ff')
                    lastNameRefs[index] = lastNameRefs[index].limitToLast(10)
                    
                    if(!this.listeners[office.meta.key])
                        this.listeners[office.meta.key] = []                    
                    let listenersForOffice2 = this.listeners[office.meta.key]
                    listenersForOffice2[listenersForOffice2.length] = lastNameRefs[index].on('value', snap => {
                        let contacts = NiceData.arrayFromSnapshot(snap)
                        
                        this.$set(this.contactsByOffice, office.meta.key + 'a', contacts)
                    })
                }

            })  
        },

        clearListeners() {
            for(let officeKey in this.listeners) {
                this.listeners[officeKey].forEach(listener => {
                    DataHelpers.getRootRef().child('tenants').child(officeKey).child('contacts').off('value', listener)
                })
            }
            this.listeners = {}
        }

    },

    watch: {

        'search': function(newVal) {
            this.debouncedRunSearch(newVal)
        },
        'visible': function(newVal) {
            if(newVal) {
                Vue.nextTick(() => {
                    this.$refs.search.focus()
                })
            }
        },
        'tenantKey': {
            handler: function(newVal) {
                this.runSearch()
            } 
        }

    },

    created () {
        TeamHelpers.fetchTeamSettings().then(settings => {
            this.blankAvatars = settings.blankAvatars
        })

        DataHelpers.fetchUser().then( () => {
            this.runSearch()
        })
    },

    mounted() {
        console.log('listeners', this.$listeners)
    }

    }
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// ContactSearch.vue?6c16c975